// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2LdRR","check":"Checkbox_check__2xLvA","label":"Checkbox_label__18RMf","small":"Checkbox_small__aGiIj"};